module.exports = __webpack_public_path__ + "img/VP-ProfiNew-Overview.f643d972.jpg";